import { reportMFRendered } from '@experience/core-hostapp-share-lib';
import { onMounted } from 'vue';

import { MF_NAME } from '@/shared/config/env';

export const useRenderReport = () => {
  onMounted(() => {
    reportMFRendered(MF_NAME);
  });
};
